// THIS FILE JUST NEEDS TO EXIST FOR THE IDE/EDITOR TO RECOGNIZE THE TYPES
// THIS FILE JUST NEEDS TO EXIST FOR THE IDE/EDITOR TO RECOGNIZE THE TYPES
// THIS FILE JUST NEEDS TO EXIST FOR THE IDE/EDITOR TO RECOGNIZE THE TYPES
// THIS FILE JUST NEEDS TO EXIST FOR THE IDE/EDITOR TO RECOGNIZE THE TYPES
// THIS FILE JUST NEEDS TO EXIST FOR THE IDE/EDITOR TO RECOGNIZE THE TYPES

/**
 * @typedef {Object} ProductBundleItem
 * @property {string} id - The unique identifier for the bundle item product.
 * @property {string} name - The name of the bundle item product.
 * @property {string} url - The URL of the bundle item product page.
 * @property {number} quantity - The quantity of this item in the bundle.
 */

/**
 * @typedef {Object} ProductItem
 * @property {string} systemId - The unique identifier for the product system.
 * @property {string} id - The unique identifier for the product.
 * @property {string} isNewsToDate - Indicates if the product is news to date.
 * @property {ProductMediaItem} newsIcon - The news icon associated with the product.
 * @property {Currency} currency - The currency information.
 * @property {string} culture - CultureInfo.CurrentUICulture.Name from C#, e.g. en-US or sv-SE etc.
 * @property {string} url - The URL of the product page.
 * @property {ProductMediaItem} campaignIcon - The campaign icon associated with the product.
 * @property {ProductMediaItem[]} images - The media items (images/videos) for the product.
 * @property {string} description - A brief description of the product.
 * @property {ProductPrice} price - The pricing details for the product.
 * @property {string} name - The name of the product.
 * @property {boolean} showWithIncludingVat - Indicates if prices should be displayed with VAT included.
 * @property {boolean} isInStock - Indicates if the product is currently in stock.
 * @property {boolean} isBuyButtonDisabled - Indicates if the buy button is disabled for the product.
 * @property {boolean} showBuyButton - Determines if the buy button should be displayed.
 * @property {boolean} showBuyButtonChannel - Indicates if the buy button is enabled for a specific channel.
 * @property {boolean} isBuyable - Determines if the product is available for purchase.
 * @property {boolean} useVariantUrl - Indicates if a variant-specific URL should be used.
 * @property {boolean} showQuantityField - Determines if the quantity field should be displayed.
 * @property {string} quantityFieldId - The identifier for the quantity field.
 * @property {TrackingProduct} trackingProduct - Tracking information for the product.
 * @property {string} websiteTheme - The theme applied to the website for this product.
 * @property {string} stockStatusDescription - A description of the product's stock status.
 * @property {boolean} isBundleProduct - Indicates if the product is a bundle containing multiple items.
 * @property {ProductBundleItem[]} bundleItems - Array of items included in the bundle (null if not a bundle product).
 */

/**
 * @typedef {Object} ProductMediaItem
 * @property {string} alt - The alternate text for the media item.
 * @property {string} mimeType - The MIME type of the media item (e.g., "image/png").
 * @property {MediaType} type - The type of media (image or video).
 * @property {string} filename - The file name of the media item.
 * @property {string} thumbnailSrcUrl - The URL of the media thumbnail.
 * @property {string} cardSrcUrl - The URL of the product card.
 * @property {string} previewSrcUrl - The URL of the media preview.
 * @property {string} fullSrcUrl - The URL of the full media source.
 */

/**
 * @typedef {Object} ProductPrice
 * @property {CampaignPriceItem} campaignPrice - The campaign price details.
 * @property {Currency} currency - The currency information.
 * @property {PriceItem} price - The price details.
 */

/**
 * @typedef {Object} CampaignPriceItem
 * @property {number} minimumQuantity - The minimum quantity for the campaign price.
 * @property {number} price - The price for the campaign.
 * @property {number} vatPercentage - The VAT percentage for the campaign price.
 * @property {number} priceWithVat - The price including VAT for the campaign.
 * @property {string} campaignSystemId - The identifier for the campaign system.
 */

/**
 * @typedef {Object} PriceItem
 * @property {number} minimumQuantity - The minimum quantity for the price.
 * @property {number} price - The base price.
 * @property {number} vatPercentage - The VAT percentage for the price.
 * @property {number} priceWithVat - The price including VAT.
 * @property {string} unitOfMeasurementSystemId - The identifier for the unit of measurement system.
 * @property {string} unitOfMeasurementTitle - The title for the unit of measurement.
 */

/**
 * @typedef {Object} Currency
 * @property {number} exchangeRate - The exchange rate for the currency.
 * @property {string} groupSeparator - The group separator used for numbers.
 * @property {string} id - The unique identifier of the currency.
 * @property {boolean} isBaseCurrency - Indicates if this is the base currency.
 * @property {string} symbol - The symbol of the currency.
 * @property {CurrencyPositions} symbolPosition - The position of the currency symbol.
 * @property {string} textFormat - The text format for currency values.
 */

/**
 * @typedef {Object} TrackingProduct
 * @property {TrackingProductItem[]} items - A list of tracking product items.
 */

/**
 * @typedef {Object} TrackingProductItem
 * @property {string} id - The unique identifier of the tracking product item.
 * @property {string} name - The name of the tracking product item.
 * @property {string} currency - The currency of the tracking product item.
 * @property {string} brand - The brand of the tracking product item.
 * @property {string} category - The primary category of the tracking product item.
 * @property {string} category2 - The secondary category of the tracking product item.
 * @property {string} category3 - The tertiary category of the tracking product item.
 * @property {string} category4 - The quaternary category of the tracking product item.
 * @property {string} category5 - The quinary category of the tracking product item.
 * @property {number} price - The price of the tracking product item.
 * @property {number} quantity - The quantity of the tracking product item.
 * @property {number} discount - The discount applied to the tracking product item.
 */

const MediaType = Object.freeze({
    IMAGE: 'image',
    VIDEO: 'video'
});

const CurrencyPositions = Object.freeze({
    LEFT: "Left",
    RIGHT: "Right",
    LEFT_WITH_SPACE: "LeftSpace",
    RIGHT_WITH_SPACE: "RightSpace",
});

export { MediaType, CurrencyPositions };
